const privacyPolicyStrings = {
  seoTitle: "La Estrellita | Privacy Policy",
  pageTitle: "Privacy Policy",
  headerTitle: "Privacy Policy",

  introParagraph:
    "At La Estrellita, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your information when you visit our website.",

  analyticsParagraph:
    "Some analytics data on this site is collected and processed by our web development partner, Code Decoded, who may use this data to analyze visitor behavior across multiple client websites they maintain. No personally identifiable information is shared between client websites.",

  section1Title: "1. Information We Collect",
  section1List: [
    "Device and Browser Information: We may collect technical data about your device and browser—such as your IP address, browser type, operating system, and unique device identifiers—to improve your browsing experience and enhance our services.",
    "Cookies: We use cookies to track your session and to store your preferences (such as dismissing cookie banners). Cookies help us personalize your experience, analyze trends, and optimize site functionality.",
    "Usage Data: We collect information about the pages you visit, the order in which you visit them, and how long you stay on each page. We may also log timestamps and detect the device type, OS, and browser version.",
    "Cross-Site Analytics: Our development partner may use anonymized or pseudonymized identifiers to analyze user behavior across multiple websites they manage. This helps them improve the functionality and design of the websites they build.",
  ],

  section2Title: "2. How We Use Your Information",
  section2List: [
    "Improving User Experience: We use collected information to operate, maintain, and enhance our website, services, and overall user experience.",
    "Analytics: Usage data is analyzed to better understand user behavior and preferences. Our development partner may aggregate anonymous analytics data to inform broader performance and compatibility improvements across client sites.",
  ],

  section3Title: "3. Information Sharing and Disclosure",
  section3List: [
    "Third-Party Service Providers: We may share your information with trusted third parties who help us operate our website, manage business activities, or provide services to you. These parties are contractually obligated to protect your data.",
    "Web Development Partner: Anonymized analytics data may be shared with and stored by our development partner for performance tracking and website optimization across multiple projects. This data does not include personally identifiable information.",
    "Legal Compliance: We may disclose your information when required by law, legal proceedings, or to protect the rights, property, or safety of La Estrellita or others.",
  ],

  section4Title: "4. Your Choices and Controls",
  section4List: [
    "Cookie Preferences: You may adjust your browser settings to refuse or delete cookies. However, some features of our website may not function correctly if cookies are disabled.",
    "Promotional Emails: You may opt out of receiving promotional emails from us. To unsubscribe, follow the instructions in our emails or contact us directly.",
    "Do Not Sell or Share My Personal Information: If you are a California resident, you have the right to opt out of the 'sale' or 'sharing' of your personal information (as defined by the California Consumer Privacy Act and California Privacy Rights Act). You may exercise this right by declining cookies.",
    "Global Privacy Control (GPC): We honor browser-based opt-out signals sent using the Global Privacy Control standard. If your browser is configured to send a GPC signal, we will treat it as a valid opt-out request.",
  ],

  section5Title: "5. Data Security",
  section5Text:
    "We implement reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no internet transmission or electronic storage method is 100% secure. While we strive to protect your data, we cannot guarantee absolute security.",

  section6Title: "6. Updates to this Privacy Policy",
  section6Text:
    "We may update this Privacy Policy from time to time. Changes will be posted on this page, and we encourage you to review it periodically.",

  section7Title: "7. Contact Us",
  section7Text:
    "If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at",
  contactEmail: " laestrellitasc@gmail.com",

  consentText:
    "By using our website, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy.",
};

export default privacyPolicyStrings;
